<template>
    <div class="lang-dropdown">
        <v-menu
            v-model="menu"
            location="bottom end"
            transition="fade-transition"
            :close-on-content-click="true"
        >
            <template #activator="{ props }">
                <v-btn
                    v-bind="props"
                    icon
                    class="lang-btn"
                    :aria-label="'Select language ' + currentLocaleName()"
                    :ripple="false"
                >
                    <svg width="61" height="50" viewBox="0 0 61 50" fill="none" xmlns="http://www.w3.org/2000/svg"
                         role="img" aria-labelledby="language-icon">
                        <title id="language-icon">Select Language</title>
                        <path
                            d="M44.5964 14.1935C44.5964 10.1187 42.8328 6.23226 39.7543 3.53032C39.7517 3.52774 39.7491 3.52516 39.744 3.52258C39.744 3.52258 39.7388 3.51742 39.7362 3.51742C37.2172 1.31097 33.9891 0.0645161 30.6476 0.0103226H30.5832C30.529 0.00258065 30.4723 0 30.4156 0C30.3588 0 30.3047 0.00258065 30.248 0.00774194H30.1835V0.0103226C26.8394 0.0645161 23.6114 1.31097 21.0898 3.51742C21.0898 3.51742 21.0872 3.52 21.0846 3.52258C21.082 3.52516 21.0769 3.52774 21.0743 3.53032C17.9983 6.23226 16.2322 10.1187 16.2322 14.1935C16.2322 18.2684 17.7714 21.6903 20.5638 24.3948C23.1576 26.9032 26.5687 28.3174 30.1758 28.3768H30.2402C30.297 28.3845 30.3537 28.3871 30.413 28.3871C30.4723 28.3871 30.5264 28.3845 30.5857 28.3794H30.6502V28.3742C34.2547 28.3148 37.6684 26.9006 40.2622 24.3923C43.0545 21.6903 44.5938 18.0671 44.5938 14.191L44.5964 14.1935ZM39.7311 22.9419C38.7616 22.1703 37.7045 21.5252 36.5778 21.0168C37.4415 19.0606 37.9185 17.0065 38.0062 14.8929H43.1783C43.0159 17.9123 41.8118 20.7303 39.7311 22.9419ZM31.1143 2.30452C32.3313 3.33936 33.391 4.56 34.2366 5.90194C33.2079 6.20645 32.1637 6.38968 31.1143 6.44645V2.30452ZM29.7168 2.30452V6.44387C28.6675 6.3871 27.6232 6.20645 26.5945 5.89936C27.4402 4.55742 28.4999 3.33936 29.7168 2.30194V2.30452ZM35.2783 20.4981C33.9247 20.031 32.5272 19.76 31.1143 19.6929V14.8929H36.6061C36.5185 16.8284 36.075 18.7071 35.2783 20.4981ZM29.7168 19.6929C28.3039 19.76 26.9065 20.031 25.5528 20.4981C24.7561 18.7071 24.3101 16.8284 24.225 14.8929H29.7168V19.6929ZM29.7168 21.0942V26.08C28.2936 24.8671 27.0947 23.4013 26.1845 21.7626C27.337 21.3806 28.5205 21.1561 29.7168 21.0942ZM31.1143 26.08V21.0942C32.3106 21.1561 33.4941 21.3806 34.6466 21.7626C33.7365 23.4013 32.535 24.8671 31.1143 26.08ZM31.1143 13.4916V7.84516C32.4035 7.78323 33.6849 7.55097 34.9405 7.14839C35.9358 9.11742 36.5056 11.2877 36.6061 13.4916H31.1143ZM35.5851 5.42452C34.724 3.99484 33.6411 2.68903 32.3906 1.56129C34.479 1.88903 36.4617 2.73548 38.1531 4.02581C37.3538 4.58065 36.4953 5.05032 35.5851 5.42452ZM25.246 5.42452C24.3359 5.05032 23.4773 4.58065 22.678 4.02581C24.3694 2.73548 26.3521 1.88903 28.4406 1.56129C27.1927 2.68645 26.1098 3.99484 25.246 5.42452ZM25.8906 7.14581C27.1462 7.54839 28.4303 7.78065 29.7194 7.84258V13.489H24.2276C24.3281 11.2852 24.8954 9.11484 25.8932 7.14581H25.8906ZM22.825 14.8903C22.9126 17.0039 23.3896 19.0581 24.2534 21.0142C23.1266 21.5252 22.0695 22.1677 21.1026 22.9394C19.0219 20.7277 17.8153 17.9123 17.6554 14.8903H22.8275H22.825ZM24.867 22.271C25.7926 23.9819 27.007 25.5252 28.4457 26.8232C26.1149 26.4619 23.9336 25.4606 22.1288 23.9148C22.9745 23.2594 23.8924 22.7071 24.8696 22.271H24.867ZM35.9641 22.271C36.9413 22.7097 37.8566 23.2594 38.7049 23.9148C36.8975 25.4606 34.7188 26.4619 32.3854 26.8232C33.8241 25.5226 35.0385 23.9794 35.9616 22.271H35.9641ZM43.1783 13.4916H38.0062C37.9082 11.12 37.31 8.78452 36.2606 6.65806C37.3255 6.20645 38.3285 5.64387 39.2515 4.96774C41.5978 7.21807 43.0004 10.2658 43.1783 13.4916ZM21.5796 4.96774C22.5053 5.64387 23.5056 6.20903 24.5705 6.65806C23.5185 8.78452 22.9229 11.12 22.825 13.4916H17.6528C17.8307 10.2658 19.2359 7.21807 21.5796 4.96774Z"
                            fill="#767474"/>
                        <path d="M0.60498 38.2581H2.62897V45.7677H7.11526V47.471H0.60498V38.2581Z" fill="#767474"/>
                        <path
                            d="M7.97889 42.8516C8.00468 42.4387 8.10781 42.0878 8.28829 41.7987C8.46878 41.5097 8.70598 41.2775 9.00249 41.102C9.299 40.9265 9.62644 40.8 9.98225 40.7278C10.3381 40.6555 10.7145 40.6194 11.1116 40.6194C11.4803 40.6194 11.8361 40.6452 12.1738 40.6968C12.5116 40.7484 12.8236 40.8439 13.102 40.9807C13.3805 41.1175 13.6074 41.3136 13.7776 41.5665C13.9503 41.8194 14.0354 42.1368 14.0354 42.5136V45.9845C14.0354 46.32 14.056 46.6194 14.0921 46.8826C14.1308 47.1458 14.1901 47.3394 14.2649 47.4684H12.4085C12.3311 47.2284 12.2873 47.0116 12.2795 46.8233C12.0037 47.1071 11.6711 47.3162 11.2792 47.4478C10.8872 47.582 10.4747 47.6491 10.0338 47.6491C9.36346 47.6491 8.81685 47.4787 8.39658 47.1407C7.97631 46.8026 7.76489 46.3045 7.76489 45.6491C7.76489 45.2878 7.82677 44.9833 7.95053 44.7329C8.07429 44.4826 8.24188 44.2865 8.45331 44.1394C8.66473 43.9923 8.89678 43.8813 9.15461 43.8039C9.41244 43.7265 9.70379 43.6671 10.0312 43.6233C10.204 43.5974 10.3999 43.5716 10.6243 43.5458C11.1734 43.4762 11.5731 43.3962 11.8232 43.3007C12.0733 43.2052 12.197 43.022 12.197 42.7458C12.197 42.3845 12.0939 42.1445 11.8876 42.0233C11.6814 41.902 11.39 41.8426 11.011 41.8426C10.632 41.8426 10.3664 41.9226 10.1602 42.08C9.95389 42.24 9.83271 42.4955 9.79919 42.8491H7.96858L7.97889 42.8516ZM12.2074 44.2065C12.1042 44.2916 11.9701 44.3562 11.8026 44.4C11.635 44.4439 11.4081 44.4852 11.127 44.5291C10.9465 44.5549 10.7996 44.5755 10.6887 44.5936C10.3458 44.6633 10.0777 44.7665 9.88944 44.9084C9.70122 45.0504 9.60582 45.2723 9.60582 45.5742C9.60582 45.8916 9.70637 46.1136 9.90748 46.24C10.1086 46.3665 10.3819 46.4258 10.7248 46.4258C11.0677 46.4258 11.3307 46.3691 11.537 46.2581C11.7433 46.1471 11.8928 46.0078 11.9882 45.84C12.0836 45.6723 12.1429 45.5097 12.1687 45.3497C12.1945 45.1897 12.2074 45.0374 12.2074 44.8904V44.2065Z"
                            fill="#767474"/>
                        <path
                            d="M15.4534 40.8H17.1938V41.7291H17.2324C17.4568 41.3678 17.7507 41.0916 18.1142 40.9033C18.4804 40.7149 18.8645 40.6194 19.2667 40.6194C19.7386 40.6194 20.1356 40.6839 20.4528 40.8129C20.7699 40.942 21.0226 41.1252 21.2056 41.36C21.3913 41.5975 21.5202 41.8813 21.5924 42.2116C21.6646 42.542 21.7007 42.9291 21.7007 43.3678V47.471H19.8701V43.7033C19.8701 43.1433 19.7798 42.7304 19.5994 42.4645C19.4189 42.1987 19.1172 42.0645 18.6969 42.0645C18.1993 42.0645 17.8384 42.2142 17.614 42.511C17.3897 42.8078 17.2789 43.2955 17.2789 43.9742V47.471H15.4482V40.8H15.4534Z"
                            fill="#767474"/>
                        <path
                            d="M29.5055 47.0452C29.5055 47.3806 29.4642 47.711 29.3843 48.0387C29.3018 48.3664 29.142 48.6787 28.8996 48.9806C28.6598 49.2826 28.304 49.5277 27.8373 49.7161C27.3681 49.9045 26.7751 50 26.0531 50C25.7102 50 25.3673 49.9561 25.0269 49.871C24.6866 49.7858 24.3772 49.6568 24.0987 49.4839C23.8203 49.311 23.5908 49.089 23.4103 48.8129C23.2299 48.5368 23.1319 48.2193 23.1138 47.8581H24.9315C25.0089 48.1858 25.1688 48.4181 25.4085 48.5626C25.6483 48.7045 25.9448 48.7742 26.2981 48.7742C26.7879 48.7742 27.1541 48.6271 27.399 48.3303C27.644 48.0335 27.7651 47.631 27.7651 47.1252V46.2477H27.7393C27.5511 46.5832 27.2727 46.8387 26.9091 47.0168C26.543 47.1923 26.1537 47.28 25.7411 47.28C25.259 47.28 24.8362 47.1948 24.4726 47.0219C24.1065 46.849 23.8074 46.6116 23.5753 46.3071C23.3433 46.0026 23.1705 45.6464 23.0597 45.2439C22.9488 44.8413 22.8921 44.4 22.8921 43.9277C22.8921 43.489 22.954 43.071 23.0777 42.6761C23.2015 42.2813 23.3871 41.9277 23.6321 41.6181C23.877 41.3084 24.1787 41.0658 24.5345 40.8903C24.8903 40.7148 25.2977 40.6245 25.7515 40.6245C26.2052 40.6245 26.5972 40.7097 26.9246 40.8748C27.252 41.0426 27.5228 41.3161 27.7368 41.6955H27.7626V40.8052H29.5029V47.0503L29.5055 47.0452ZM27.3603 45.3548C27.6311 44.9935 27.7651 44.56 27.7651 44.0516C27.7651 43.7677 27.7368 43.5045 27.6826 43.2568C27.6259 43.0116 27.5382 42.7948 27.4171 42.6064C27.2959 42.4181 27.136 42.2684 26.9323 42.16C26.7312 42.0516 26.4889 42 26.2027 42C25.7128 42 25.3441 42.1806 25.094 42.5419C24.8439 42.9032 24.7201 43.3548 24.7201 43.8968C24.7201 44.1548 24.7459 44.4 24.7975 44.6323C24.849 44.8645 24.9341 45.0761 25.0501 45.2645C25.1662 45.4529 25.3209 45.6077 25.5143 45.7239C25.7076 45.84 25.9371 45.8968 26.2027 45.8968C26.7003 45.8968 27.0845 45.7161 27.3578 45.3548H27.3603Z"
                            fill="#767474"/>
                        <path
                            d="M37.2275 47.471H35.4871V46.542H35.4485C35.2242 46.9033 34.9302 47.1794 34.5667 47.3678C34.2006 47.5562 33.8164 47.6517 33.4142 47.6517C32.9423 47.6517 32.5453 47.5871 32.2281 47.4581C31.911 47.3291 31.6583 47.1433 31.4753 46.9033C31.2896 46.6633 31.1607 46.3794 31.0885 46.0517C31.0163 45.7239 30.9802 45.342 30.9802 44.9033V40.8H32.8108V44.5678C32.8108 45.1278 32.9037 45.5407 33.0893 45.8065C33.2749 46.0723 33.574 46.2065 33.9866 46.2065C34.4842 46.2065 34.8451 46.0568 35.0695 45.76C35.2938 45.4633 35.4046 44.9755 35.4046 44.2968V40.8H37.2353V47.471H37.2275Z"
                            fill="#767474"/>
                        <path
                            d="M38.5424 42.8516C38.5682 42.4387 38.6713 42.0878 38.8518 41.7987C39.0323 41.5097 39.2695 41.2775 39.566 41.102C39.8625 40.9265 40.1899 40.8 40.5457 40.7278C40.9015 40.6555 41.278 40.6194 41.675 40.6194C42.0437 40.6194 42.3996 40.6452 42.7373 40.6968C43.0751 40.7484 43.3871 40.8439 43.6655 40.9807C43.944 41.1175 44.1709 41.3136 44.341 41.5665C44.5138 41.8194 44.5989 42.1368 44.5989 42.5136V45.9845C44.5989 46.32 44.6195 46.6194 44.6556 46.8826C44.6943 47.1458 44.7536 47.3394 44.8283 47.4684H42.9719C42.8946 47.2284 42.8508 47.0116 42.843 46.8233C42.5671 47.1071 42.2345 47.3162 41.8426 47.4478C41.4507 47.582 41.0382 47.6491 40.5973 47.6491C39.9269 47.6491 39.3803 47.4787 38.9601 47.1407C38.5398 46.8026 38.3284 46.3045 38.3284 45.6491C38.3284 45.2878 38.3902 44.9833 38.514 44.7329C38.6378 44.4826 38.8054 44.2865 39.0168 44.1394C39.2282 43.9923 39.4603 43.8813 39.7181 43.8039C39.9759 43.7265 40.2673 43.6671 40.5947 43.6233C40.7675 43.5974 40.9634 43.5716 41.1877 43.5458C41.7369 43.4762 42.1366 43.3962 42.3867 43.3007C42.6368 43.2052 42.7605 43.022 42.7605 42.7458C42.7605 42.3845 42.6574 42.1445 42.4511 42.0233C42.2448 41.902 41.9535 41.8426 41.5745 41.8426C41.1955 41.8426 40.9299 41.9226 40.7236 42.08C40.5174 42.24 40.3962 42.4955 40.3627 42.8491H38.5321L38.5424 42.8516ZM42.7708 44.2065C42.6677 44.2916 42.5336 44.3562 42.366 44.4C42.1984 44.4439 41.9715 44.4852 41.6905 44.5291C41.51 44.5549 41.3631 44.5755 41.2522 44.5936C40.9093 44.6633 40.6411 44.7665 40.4529 44.9084C40.2647 45.0504 40.1693 45.2723 40.1693 45.5742C40.1693 45.8916 40.2698 46.1136 40.471 46.24C40.6721 46.3665 40.9454 46.4258 41.2883 46.4258C41.6312 46.4258 41.8942 46.3691 42.1005 46.2581C42.3067 46.1471 42.4563 46.0078 42.5517 45.84C42.6471 45.6723 42.7064 45.5097 42.7322 45.3497C42.7579 45.1897 42.7708 45.0374 42.7708 44.8904V44.2065Z"
                            fill="#767474"/>
                        <path
                            d="M52.4266 47.0452C52.4266 47.3806 52.3854 47.711 52.3055 48.0387C52.223 48.3664 52.0631 48.6787 51.8207 48.9806C51.581 49.2826 51.2251 49.5277 50.7585 49.7161C50.2892 49.9045 49.6962 50 48.9743 50C48.6313 50 48.2884 49.9561 47.9481 49.871C47.6077 49.7858 47.2983 49.6568 47.0199 49.4839C46.7414 49.311 46.512 49.089 46.3315 48.8129C46.151 48.5368 46.053 48.2193 46.035 47.8581H47.8527C47.93 48.1858 48.0899 48.4181 48.3297 48.5626C48.5695 48.7045 48.866 48.7742 49.2192 48.7742C49.7091 48.7742 50.0752 48.6271 50.3202 48.3303C50.5651 48.0335 50.6863 47.631 50.6863 47.1252V46.2477H50.6605C50.4723 46.5832 50.1938 46.8387 49.8303 47.0168C49.4641 47.1923 49.0748 47.28 48.6623 47.28C48.1801 47.28 47.7573 47.1948 47.3937 47.0219C47.0276 46.849 46.7285 46.6116 46.4965 46.3071C46.2644 46.0026 46.0917 45.6464 45.9808 45.2439C45.87 44.8413 45.8132 44.4 45.8132 43.9277C45.8132 43.489 45.8751 43.071 45.9989 42.6761C46.1226 42.2813 46.3083 41.9277 46.5532 41.6181C46.7982 41.3084 47.0998 41.0658 47.4556 40.8903C47.8114 40.7148 48.2188 40.6245 48.6726 40.6245C49.1264 40.6245 49.5183 40.7097 49.8457 40.8748C50.1732 41.0426 50.4439 41.3161 50.6579 41.6955H50.6837V40.8052H52.4241V47.0503L52.4266 47.0452ZM50.2815 45.3548C50.5522 44.9935 50.6863 44.56 50.6863 44.0516C50.6863 43.7677 50.6579 43.5045 50.6038 43.2568C50.547 43.0116 50.4594 42.7948 50.3382 42.6064C50.217 42.4181 50.0572 42.2684 49.8535 42.16C49.6524 42.0516 49.41 42 49.1238 42C48.6339 42 48.2652 42.1806 48.0151 42.5419C47.765 42.9032 47.6413 43.3548 47.6413 43.8968C47.6413 44.1548 47.6671 44.4 47.7186 44.6323C47.7702 44.8645 47.8553 45.0761 47.9713 45.2645C48.0873 45.4529 48.242 45.6077 48.4354 45.7239C48.6288 45.84 48.8582 45.8968 49.1238 45.8968C49.6214 45.8968 50.0056 45.7161 50.2789 45.3548H50.2815Z"
                            fill="#767474"/>
                        <path
                            d="M55.4047 44.5806C55.4305 45.1561 55.58 45.5819 55.8559 45.858C56.1318 46.1341 56.5263 46.2709 57.0419 46.2709C57.3952 46.2709 57.7071 46.1832 57.983 46.0051C58.2589 45.8296 58.4265 45.6283 58.4858 45.4038H60.0972C59.8471 46.1702 59.4604 46.7354 58.9318 47.1019C58.4033 47.4683 57.751 47.649 56.9775 47.649C56.4618 47.649 55.9926 47.5638 55.5723 47.3986C55.152 47.2309 54.791 46.9909 54.4971 46.6761C54.2006 46.3612 53.9737 45.987 53.8139 45.5535C53.654 45.1199 53.5767 44.6477 53.5767 44.1419C53.5767 43.6361 53.6592 43.1793 53.8216 42.7483C53.984 42.3173 54.2161 41.9432 54.5177 41.6257C54.8194 41.3083 55.1804 41.0606 55.6006 40.8825C56.0209 40.7044 56.4824 40.6167 56.98 40.6167C57.5034 40.6167 57.9701 40.7148 58.3775 40.9057C58.7849 41.0993 59.1252 41.3651 59.3959 41.7006C59.6667 42.0361 59.8729 42.4232 60.0147 42.8619C60.1566 43.3006 60.2287 43.7651 60.2287 44.2554C60.2287 44.289 60.2236 44.3406 60.2159 44.4102V44.578H55.4073L55.4047 44.5806ZM58.3827 43.4193C58.2976 42.9367 58.1403 42.5806 57.9108 42.3483C57.6839 42.1161 57.3539 41.9999 56.9233 41.9999C56.6474 41.9999 56.4154 42.0464 56.222 42.1419C56.0286 42.2373 55.8714 42.3561 55.7502 42.5032C55.629 42.6502 55.5439 42.8025 55.4924 42.9625C55.4408 43.1225 55.4098 43.2748 55.4021 43.4193H58.3801H58.3827Z"
                            fill="#767474"/>
                    </svg>
                </v-btn>
            </template>

            <v-sheet class="lang-menu" role="menu">
                <div
                    v-for="(loc, index) in locales"
                    :key="loc.code"
                    ref="langItemRefs"
                    :aria-checked="loc.code === currentLocale"
                    class="lang-item"
                    @click="changeLocale(loc.code)"
                    @keydown="onLangItemKeydown($event, index, loc.code)"
                    tabindex="1"
                    role="menuitemradio"
                    aria-roledescription="button"
                >
                    <svg
                        v-if="loc.code === currentLocale"
                        width="9"
                        height="8"
                        viewBox="0 0 9 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        class="lang-check"
                    >
                        <path
                            d="M8.61189 0.972961C8.83016 1.20725 8.82897 1.57076 8.60919 1.80362L3.23265 7.5L0.38531 4.4436C0.168237 4.21059 0.168238 3.84942 0.385311 3.6164C0.625056 3.35906 1.03268 3.35881 1.27274 3.61586L3.23265 5.71453L7.72676 0.969321C7.96763 0.715 8.37313 0.716668 8.61189 0.972961Z"
                            fill="white"
                        />
                    </svg>
                    <span class="lang-label">{{ loc.name }}</span>
                </div>
            </v-sheet>
        </v-menu>
    </div>
</template>

<script setup lang="ts">
import {ref, watch, onBeforeUpdate, nextTick} from "vue"
import {useI18n} from "vue-i18n"

const menu = ref(false)
const {locale} = useI18n()
const currentLocale = ref(locale.value)

const locales = [
    {code: "ko", name: "한국어"},
    {code: "ar", name: "اللغة العربية"},
    {code: "cz", name: "Czech"},
    {code: "de", name: "German"},
    {code: "en", name: "English"},
    {code: "es", name: "Español"},
    {code: "fr", name: "Français"},
    {code: "ja", name: "日本語"},
    {code: "kz", name: "қазақ"},
    {code: "pt", name: "Português"},
    {code: "sv", name: "Svenska"},
    {code: "sh", name: "српски језик"},
    {code: "sr", name: "srpski jezik"},
    {code: "hr", name: "hrvatski"},
];

const changeLocale = (code: string) => {
    locale.value = code
    currentLocale.value = code
    menu.value = false
}

// 👉 lang-item DOM element 들 모아두는 배열
const langItemRefs = ref<HTMLElement[]>([])

const setLangItemRef = (el: HTMLElement | null, index: number) => {
    if (el) {
        langItemRefs.value[index] = el
    }
}

// v-for 다시 렌더될 때 ref 배열 초기화
onBeforeUpdate(() => {
    langItemRefs.value = []
})

// 메뉴 열릴 때, 현재 locale 에 해당하는 항목에 포커스 주기
watch(menu, async (isOpen) => {
    if (!isOpen) return

    await nextTick()
    const index = locales.findIndex((l) => l.code === currentLocale.value) || 0
    const target = langItemRefs.value[index] || langItemRefs.value[0]
    target?.focus()
})

// 키보드 이벤트 처리
const onLangItemKeydown = (
    event: KeyboardEvent,
    index: number,
    code: string
) => {
    const key = event.key

    // ↑ / ↓ 로 포커스 이동
    if (key === "ArrowDown" || key === "ArrowUp") {
        event.preventDefault()

        const lastIndex = locales.length - 1
        let nextIndex = index

        if (key === "ArrowDown") {
            nextIndex = index === lastIndex ? 0 : index + 1
        }
        else if (key === "ArrowUp") {
            nextIndex = index === 0 ? lastIndex : index - 1
        }

        const nextEl = langItemRefs.value[nextIndex]
        nextEl?.focus()
        return
    }

    // Enter / Space 로 선택
    if (key === "Enter" || key === " " || key === "Spacebar") {
        event.preventDefault()
        event.stopPropagation()
        changeLocale(code)
    }
}

const currentLocaleName = () => {
    const lang = locales.find(e => e.code === currentLocale.value)
    return lang ? lang.name : "없음"
}

</script>

<style scoped>
.lang-dropdown {
    display: inline-block;
    position: relative;
    margin-left: 20px;
}

.lang-btn {
    width: 3.5rem;
    height: 3.5rem;
    background: transparent !important;
    box-shadow: none !important;
    border: none;
    color: #767474 !important;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: opacity 0.2s ease;
}

.lang-btn:hover {
    opacity: 0.8;
}

.lang-btn svg {
    overflow: visible;
    padding-right: 2px;
}

.lang-menu {
    background-color: #aaabab !important;
    border: none;
    border-radius: 6px;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25);
    margin-top: 10px;
    padding: 6px 0;
    min-width: 160px;
    max-height: 375px;
    overflow-y: auto;
}

.lang-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-size: 20px;
    color: #f7f7f7;
    padding: 10px 16px;
    cursor: pointer;
    transition: background 0.2s ease;
}

.lang-check {
    margin-right: 8px;
    flex-shrink: 0;
}

.lang-label {
    flex-grow: 1;
    white-space: nowrap;
}

.lang-item:hover {
    background-color: #ea5414;
    color: #ffffff;
}
</style>